import { hydrateQueryFromPersistedCache, removePersistedQueryCacheEntry, } from '#pplx/frontend/react-query/internal/persistedQueryCache.js';
import { keepCacheOnError } from '#pplx/frontend/react-query/utils.js';
import { hashKey } from '@tanstack/react-query';
export function getPersistedQueryOptions({ options, queryClient, allowPersist, }) {
    const originalQueryFn = options.queryFn;
    const skipPersistence = options.meta?.skipPersistence === true;
    const isPersistable = allowPersist && typeof originalQueryFn === 'function' && !skipPersistence;
    const persistedQueryFn = async (args) => {
        if (!isPersistable)
            throw new Error('Persisted queryFn must be a function');
        const queryKey = args.queryKey;
        const persistKey = hashKey(queryKey);
        try {
            const result = originalQueryFn(args);
            hydrateQueryFromPersistedCache({ queryClient, queryKey, persistKey });
            return await result;
        }
        catch (error) {
            if (keepCacheOnError(error)) {
                const data = queryClient.getQueryData(queryKey);
                if (data)
                    return data;
                throw error;
            }
            else {
                removePersistedQueryCacheEntry({ persistKey });
                throw error;
            }
        }
    };
    return isPersistable ? { ...options, queryFn: persistedQueryFn } : options;
}
//# sourceMappingURL=getPersistedQueryOptions.js.map